import React, { useState } from "react";
import { IconView, IconViewOff } from "../shared/icons/IconLib";

/**
 * Password field with an in-field show/hide eye toggle.
 * Forwards standard input props (id, value, onChange, autoComplete, required, disabled, …).
 * Visibility state is local to each instance.
 */
function PasswordInput({ disabled, id, ...rest }) {
  const [visible, setVisible] = useState(false);
  const showLabel = visible ? "Hide password" : "Show password";

  return (
    <div className="password-input">
      <input
        {...rest}
        id={id}
        type={visible ? "text" : "password"}
        disabled={disabled}
      />
      <button
        type="button"
        className="password-input__toggle"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => setVisible((v) => !v)}
        aria-label={showLabel}
        title={showLabel}
        aria-pressed={visible}
        {...(id ? { "aria-controls": id } : {})}
        disabled={disabled}
      >
        {visible ? <IconViewOff size={20} /> : <IconView size={20} />}
      </button>
    </div>
  );
}

export default PasswordInput;
